import { render, staticRenderFns } from "./EndGroupModal.vue?vue&type=template&id=55ca7fcb&"
import script from "./EndGroupModal.vue?vue&type=script&lang=js&"
export * from "./EndGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports